import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { BrandManagersPersonaPage } from "@/components/site/BrandManagersPersonaPage";
import { BRAND_MANAGERS_META_DESCRIPTION } from "@/content/meta/BrandManagersPersonaPage";

export const Route = createFileRoute("/who-we-help/brand-managers")({
  head: () => ({
    meta: [
      { title: "Media Intelligence for Brand Managers | Perceptica" },
      { name: "description", content: BRAND_MANAGERS_META_DESCRIPTION },
      { property: "og:title", content: "Media Intelligence for Brand Managers | Perceptica" },
      { property: "og:description", content: BRAND_MANAGERS_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Intelligence for Brand Managers | Perceptica" },
      { name: "twitter:description", content: BRAND_MANAGERS_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/who-we-help/brand-managers" },
      ...ogImageMeta("en", "/who-we-help/brand-managers"),
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/who-we-help/brand-managers" }),
  }),
  component: BrandManagersPersonaPage,
});
